import React from 'react';
import { Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import { useAuth } from '../context/AuthContext';

interface Props {
  children: React.ReactNode;
  requireAdmin?: boolean;
  requirePermission?: string;
}

export default function ProtectedRoute({ children, requireAdmin, requirePermission }: Props) {
  const { isAuthenticated, isLoading, isAdmin, hasPermission } = useAuth();

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <Spin />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/orders" replace />;
  }

  if (requirePermission && !hasPermission(requirePermission)) {
    return <Navigate to="/orders" replace />;
  }

  return <>{children}</>;
}
